/* Component Dependencies */
var roomDetailsImageGalleryTemplate = require('templates/roomDetailsImageGallery.hbs');
var AriesComponent = require('libs/aries-component');
var gallery = require('libs/gallery');

AriesComponent.create({
  type: 'roomDetailsImageGallery',
  template: {
    'roomDetailsImageGallery': roomDetailsImageGalleryTemplate
  },

  bindEvents: function ($) {
    var _self = this,
       currentImageWrapper,
       currentImgNumber = 0,
       containerWidth,
       captionContainer = this.$el.find('.m-caption-container'),
       loadMoreImages = _self.beforeChange.bind(_self);

    if(_self.$el.find('.mi-carousel').length) {

    		var $carousel;
						_self.parentSelector = $('[data-component-id="' + _self.componentId + '"]'),
						$carousel = _self.parentSelector.find('.mi-carousel');
						var initialSlide = $carousel.data('initialslide');
						if(initialSlide) {
							$carousel.on('init', function(event, slick) {
							setTimeout(function() {
									$carousel.addClass('mi-prevent-reinit');
									$carousel.slick('slickGoTo', $carousel.data('initialslide'));
							}, 0); });
						}
      $(_self.$el.find('.mi-carousel')).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        _self.currentImgNumber = nextSlide+1;
        _self.updateImageInfo();

        //showing/hiding the caption container on the basis of caption value
        currentImageWrapper = _self.$el.find('.slick-slide[data-slick-index='+ nextSlide +']'); 
        currentImageWrapper.attr('data-caption') ? captionContainer.removeClass("is-hidden") :  captionContainer.addClass("is-hidden");
      }); 
      $(document).trigger('GLOBAL_ELEMENTS_REINIT');
    } else {
      _self.$el.find('.m-photo-gallery-slider ul').gallery({beforeChange:loadMoreImages});
      _self.currentSlide =1;
    }
    $(window).on('resize',function(){
      containerWidth = _self.$el.find(".article-content").width();
      captionContainer.width(containerWidth);
    });
  },

  /**
   * This function is used to update the current image number and title
   * @returns {Object} Current component instance
   */
  updateImageInfo: function _updateImageInfo() {
    this.$el.find('.current-image-number').html(this.currentImgNumber);
    var imageTitle = $(this.$el.find('.slider-slide')).eq(this.currentImgNumber).data('title');
    this.$el.find('.image-title').text(imageTitle);
    return this;
  },
  /**
  *Changes for lazy loading of images in slider.
  *@param {object} event object on load times
  */
  beforeChange: function(event){
    var _self = this,
    initialLoad = _self.$el.find('ul').data('initialload');

      if(event.hasClass('next-btn')){
        var slideToLoad = _self.$el.find('li[data-index="'+parseInt(initialLoad+_self.currentSlide)+'"] img');
        _self.currentSlide++;
        if(slideToLoad.data('src') && !slideToLoad.attr('src') ){
          slideToLoad.attr('src',slideToLoad.data('src'));
        }        
      }else{
        _self.currentSlide--;
      }
  }
});
